import { render, staticRenderFns } from "./recent-bets-table.vue?vue&type=template&id=21d1cb01&scoped=true&"
import script from "./recent-bets-table.vue?vue&type=script&lang=js&"
export * from "./recent-bets-table.vue?vue&type=script&lang=js&"
import style0 from "./recent-bets-table.vue?vue&type=style&index=0&id=21d1cb01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1cb01",
  null
  
)

export default component.exports